module.exports = __webpack_public_path__ + "img/bannerS002.33e9d3c1.png";